import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { SquarePen } from 'lucide-react';

import './Input.scss';

import { ErrorMessage, SuccessMessage } from './CreditCardInput';

import useIpCountryDefault from '../../../hooks/useIpCountryDefault';

import { normalizeCountryCallingCode } from '../../../Utils/IpCountry';


export default function CountryCodePhoneNumber(props) {
  const {
    value = '', setValue = () => {}, setCountryCode = () => {}, setRequireEmail = () => {}, setEmail = () => {}, 
    resendNumber = false, handleChangeNumber = () => {}, otpValidate = false, currentError = '', currentMessage = '', 
    formValidationError = '', countryCode = ''
  } = props;
  const ipCountryDefault = useIpCountryDefault();
  const effectiveCountryCode = normalizeCountryCallingCode(countryCode || ipCountryDefault.dialCode);

  return (
    <div className="countryCodePhoneNumberWrapper">
      <div className="phoneInputContainer">
        <PhoneInput
          country={ipCountryDefault.countryIso2}
          inputClass="fontInter"
          inputMode="numeric"
          countryCodeEditable={false}
          value={effectiveCountryCode + value}
          onChange={(phone, country) => {
            const phoneWithoutCountryCode = phone.startsWith(country.dialCode)
              ? phone.substring(country.dialCode.length).trim()
              : phone.trim();
            setValue(phoneWithoutCountryCode);
            setCountryCode(country.dialCode);
            if (country.dialCode !== "91") {
              setRequireEmail(true);
            } else {
              setRequireEmail(false);
              setEmail("");
            }
          }}
          placeholder="Mobile Number"
          disableDropdown={otpValidate}
          disabled={resendNumber}
        />
        {resendNumber && (
          <div className="editNumberButton" onClick={handleChangeNumber}>
            <SquarePen size={18} />
          </div>
        )}
      </div>
      {currentMessage && (
        <SuccessMessage message={currentMessage} />
      )}
      {(currentError || formValidationError) && !currentMessage && (
        <ErrorMessage error={formValidationError || currentError} />
      )}
    </div>
  );
}

CountryCodePhoneNumber.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  setCountryCode: PropTypes.func,
  setRequireEmail: PropTypes.func,
  setEmail: PropTypes.func,
  resendNumber: PropTypes.bool,
  handleChangeNumber: PropTypes.func,
  otpValidate: PropTypes.bool,
  currentError: PropTypes.string,
  currentMessage: PropTypes.string,
  formValidationError: PropTypes.string,
  countryCode: PropTypes.string
};
